module.exports = __webpack_public_path__ + "images/interview-Amazon-2.svg";